;(function ($) {

    "use strict";

    var faq = {

      elems: null,

      init: function(itemClass) {

        faq.elems = $(itemClass);

        if (faq.elems.length) {

          faq.getAnswerMaxHeight('.answer-text');

          faq.elems.find('.anchor').on('click', function() {
            faq.showAnswer($(this).closest(itemClass), '.answer-text');
          })
          faq.elems.find('.answer-text').on('click', function() {
            faq.showAnswer($(this).closest(itemClass), '.answer-text');
          })
        }

      },

      showAnswer: function(question, answerCls) {
        question.toggleClass('active');
        var answer = question.find(answerCls);
        if (question.hasClass('active')) {
          answer.css('max-height', answer.attr('data-maxHeight'));
        }
        else {
          answer.css('max-height', 0);
        }
      },

      getAnswerMaxHeight: function(cls) {
        var elems = faq.elems.find(cls);
        for(var i = 0; i < elems.length; i++) {
          $(elems[i]).attr('data-maxHeight', $(elems[i]).innerHeight() + 'px');
        }
        elems.css('max-height', 0);
      }
    };
    faq.init('.question');


})(jQuery);